import React from 'react';

const DataCollectionIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <g fill="none">
      <circle cx="30" cy="30" r="30" fill={props.color || '#4A7AFA'} />
      <path
        fill="#000000"
        d="M44.86 40.75l-7.06-5.83a12.5 12.5 0 1 0-2.31 2.31l5.83 7.06a2.51 2.51 0 1 0 3.54-3.53v-.01z"
      />
      <circle cx="27.89" cy="27.3" r="9.5" fill="#FFFFFF" transform="rotate(-45 27.894 27.302)" />
      <path fill={props.color || '#4A7AFA'} d="M36 24.84L25.39 35.45A8.5 8.5 0 0 0 36 24.84z" />
      <path
        fill={props.color || '#4A7AFA'}
        d="M21.88 33.32c.99.99 2.2 1.72 3.54 2.12L36 24.84a8.46 8.46 0 0 0-2.12-3.54l-.37-.34-12 12c.14.12.25.2.37.36z"
        opacity=".5"
      />
    </g>
  </svg>
);

export default DataCollectionIcon;
